import { Icon } from '../../../../components/icons'
import { Button } from '../../../../components/ui/button'

export const ActionsOfCandidates = ({
  loading,
  status,
  align = 'centered',
  actions = {
    setAccept: () => {},
    setReject: () => {},
    setCheckin: () => {},
    setCheckout: () => {},
    setPay: () => {},
    setCancel: () => {},
    setRecover: () => {},
    setNotify: () => {},
  },
}) => {
  return (
    <Button.Root align={align}>
      {status === 0 && (
        <>
          <Button.Content>
            <Button.Bt
              colorText={'has-text-white'}
              color="is-success"
              action={() => {
                actions.setAccept()
              }}
              loading={loading}
              title="Aceitar Candidatura"
              titleBehind="Aceitar Candidatura"
            >
              <Icon size={20} margin={-5}>
                check
              </Icon>
            </Button.Bt>
          </Button.Content>
          <Button.Content>
            <Button.Bt
              color="is-danger"
              colorText={'has-text-white'}
              type="button"
              action={async () => {
                await actions.setReject()
              }}
              loading={loading}
              title="Rejeitar Candidatura"
              titleBehind="Rejeitar Candidatura"
            >
              <Icon size={15} margin={-1}>
                multiply
              </Icon>
            </Button.Bt>
          </Button.Content>
        </>
      )}

      {(status === 1 || status === 11) && (
        <Button.Content>
          <Button.Bt
            colorText={'has-text-white'}
            color="is-info"
            action={async () => {
              await actions.setRecover()
            }}
            loading={loading}
            title="Recuperar Candidatura"
            titleBehind="Recuperar Candidatura"
          >
            <Icon size={20} margin={-5}>
              invite
            </Icon>
            <Icon size={20} margin={-5}>
              arrowUp
            </Icon>
          </Button.Bt>
        </Button.Content>
      )}

      {status === 2 && (
        <Button.Content>
          <Button.Bt
            color="is-warning"
            colorText={'has-text-dark'}
            type="button"
            action={async () => {
              await actions.setNotify()
            }}
            loading={loading}
            title="Notificar"
            titleBehind="Notificar"
          >
            <Icon size={15} margin={-1}>
              message
            </Icon>
          </Button.Bt>
        </Button.Content>
      )}

      {status === 3 && (
        <Button.Content>
          <Button.Bt
            color="is-success"
            colorText={'has-text-white'}
            type="button"
            action={async () => {
              await actions.setCheckin()
            }}
            loading={loading}
            title="Check-in"
            titleBehind="Check-in"
          >
            <Icon size={15} margin={-1}>
              checkin
            </Icon>
          </Button.Bt>
        </Button.Content>
      )}

      {(status === 5 || status === 8) && (
        <Button.Content>
          <Button.Bt
            color="is-warning"
            colorText={'has-text-white'}
            type="button"
            action={async () => {
              await actions.setCheckout()
            }}
            loading={loading}
            title="Check-out"
            titleBehind="Check-out"
          >
            <Icon size={15} margin={-1}>
              checkout
            </Icon>
          </Button.Bt>
        </Button.Content>
      )}

      {status === 9 && (
        <Button.Content>
          <Button.Bt
            color="is-success"
            colorText={'has-text-white'}
            type="button"
            action={async () => {
              await actions.setPay()
            }}
            loading={loading}
            title="Pagar Colaborador"
            titleBehind="Pagar Colaborador"
          >
            <Icon size={15} margin={-1}>
              dollar
            </Icon>
          </Button.Bt>
        </Button.Content>
      )}

      {(status !== 1 && status !== 4 && status < 5) || status === 12 ? (
        <Button.Content>
          <Button.Bt
            color="is-danger"
            colorText={'has-text-white'}
            type="button"
            action={async () => {
              await actions.setCancel()
            }}
            loading={loading}
            title="Cancelar Candidatura"
            titleBehind="Cancelar Candidatura"
          >
            <Icon size={15} margin={-1}>
              trash
            </Icon>
          </Button.Bt>
        </Button.Content>
      ) : null}
    </Button.Root>
  )
}
